import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Container, Image  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link, useParams } from 'react-router-dom';
import AITalk from './AITalk';
import ApiFetch from './ApiFetch';
import { LanguageCtx, LoginInfo } from '../App';
import { isLoggin } from '../service/LoginService';

const AlTalkSingle = () => {
    async function getCharacterInfo(characterId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/character/info/"+characterId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    const [characterInfo,setCharacterInfo] = useState([])
    const [characterDetail,setCharacterDetail] = useState([])
    const [characterId,setCharacterId] = useState("")
    const [characterName,setCharacterName] = useState("")
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // 言語設定
    const {language,setLanguage} = useContext(LanguageCtx)
    const param = useParams()
    useEffect(() => {
        setCharacterId(param.characterId === undefined ? "" : param.characterId)
        if(param.characterId !== ""){
            getCharacterInfo(param.characterId).then(json => {
                if(json.result){
                    setCharacterInfo(json.info)
                    setCharacterDetail(json.detail)
                }
            })
        }
    }, [param.characterId]);
    useEffect(()=>{
        // ログイン情報取得
        if(loginInfo.length === 0){
            isLoggin().then(json => {
                setLoginInfo(json)
                if(json.result){
                    i18n.changeLanguage(json.language)
                    setLanguage(json.language)
                } else {
                    let s = localStorage
                    let l = s.getItem("language")
                    if(l !== null){
                        i18n.changeLanguage(l)
                        setLanguage(l)
                        return
                    }
                    if(window.navigator.language.startsWith("ja")){
                        s.removeItem("language")
                        s.setItem("language","ja")
                        i18n.changeLanguage("ja")
                        setLanguage("ja")
                    }  else if(window.navigator.language.startsWith("en")){
                        s.removeItem("language")
                        s.setItem("language","en")
                        i18n.changeLanguage("en")
                        setLanguage("en")
                    }
                }
            })
        }
    },[loginInfo])
    return(
    <div className="wrapper">
        <div className='w-100'>
            <AITalk characterId={param.characterId} characterName={characterInfo.character_name} show={true} setPoint={() => {}} setAIAssistant={(e) => window.history.back} hiddenCloseButton={true} />
        </div>

    </div>
    )
}

export default AlTalkSingle;
